import 'react-app-polyfill/ie11'; // remove when IE11 is dead
import 'core-js'; // remove when IE11 is dead
import 'svgxuse'; // remove when IE11 is dead
import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App/App';
import * as serviceWorker from './serviceWorker';

import GlobalErrorContext from './shared/context/GlobalErrorContext.js';
import GlobalUserContext from './shared/context/GlobalUserContext.js';
import GlobalAppointment from './shared/context/GlobalAppointment.js';
import GlobalIsRegistered from './shared/context/GlobalIsRegistered.js';
import GlobalIsBlocked from './shared/context/GlobalIsBlocked.js';

ReactDOM.render(
  <React.StrictMode>
    <GlobalErrorContext>
      <GlobalUserContext>
        <GlobalIsRegistered>
          <GlobalIsBlocked>
            <GlobalAppointment>
              <App />
            </GlobalAppointment>
        </GlobalIsBlocked>
        </GlobalIsRegistered>
      </GlobalUserContext>
    </GlobalErrorContext>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
